module.exports = fox._r("images/address_info_000000.png", __webpack_public_path__ + "images/address_info_000000.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/address_info_000000.png
// module id = 977
// module chunks = 4